export default "__VITE_PUBLIC_ASSET__60d5305f__"